import {UseQueryResult} from "@tanstack/react-query";
import {createContext, useContext} from "react";
import {WorkOrderContextType} from "../types/WorkOrderContextType";
import {WorkOrderDetails} from "../types/WorkOrderDetails";

enum RefetchScope {
	Files,
	Notes
}

const WorkOrderContext = createContext<{
	order: WorkOrderContextType,
	modifyOrder: (details: WorkOrderDetails) => void
	refetchOrder: (scope?: RefetchScope) => Promise<UseQueryResult>
}>
	({
		order: {} as WorkOrderContextType,
		modifyOrder: () => { },
		refetchOrder: (scope?: RefetchScope) => { return new Promise(() => { }); }
	});

const useWorkOrder = () => useContext(WorkOrderContext);

export { WorkOrderContext, useWorkOrder, RefetchScope }
